export const SortingDirection = {
  desc: 'desc',
  asc: 'asc',
};

const getSortingDirection = (isDesc?: boolean) => (isDesc ? 'desc' : 'asc');

export default getSortingDirection;
